<template>
  <div class="audio_play" @click="handlePlay">
    <img
      v-show="(icon && !isplayed) || !activeIcon"
      class="audio_play__icon"
      :src="icon"
      alt=""
    />
    <img
      v-show="!isplayed && hoverIcon"
      class="audio_play__icon audio_play__icon--hover"
      :src="hoverIcon"
      alt=""
    />
    <img
      v-show="activeIcon && isplayed"
      class="audio_play__icon audio_play__icon--active"
      :src="activeIcon"
      alt=""
    />
  </div>
</template>
<script>
import { eventAudio } from "./audio";
import Vue from "vue";
export default {
  name: "MeAudio",
  props: {
    cache: {
      default: true,
      type: Boolean,
    },
    storageKey: {
      default: "",
      type: String,
    },
    storageKeySuffix: {
      type: String,
    },
    src: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Array,
      required: true,
    },
    effectSrc: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Array,
      required: false,
    },
    effectConfig: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: "",
    },
    activeIcon: {
      type: String,
      default: "",
    },
    hoverIcon: {
      type: String,
      default: "",
    },
    volume: {
      type: Number,
      default: 1,
      validator(val) {
        return val >= 0 || val <= 1;
      },
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    preload: {
      type: Boolean,
      default: true,
    },
    fade: {
      type: Array,
      default: () => [1000, 1000],
    },
    doPlay: {
      type: Boolean,
      default: true,
    },
    html5: {
      type: Boolean,
      default: undefined,
    },
    seekInterval: {
      type: Number,
    },
  },
  data() {
    return {
      sounds: [],
      player: null,
      effectPlayer: null,
      isplayed: false,
      isSprite: false,
    };
  },
  watch: {
    index(val) {
      if (this.player) {
        this.player.switchSrcIndex(val);
      }
    },
    effectSrc(val) {
      if (!val || !!this.effectPlayer) {
        return;
      }
      this.effectPlayer?.unload();
      this.initEffectPlayer(val);
    },
    volume(val) {
      if (this.player) {
        this.player.changeVolume(val);
      }
      if (typeof this.effectConfig.volume === "undefined") {
        this.changeEffectVolume(val);
      }
    },
    "effectConfig.volume"(newVal) {
      if (typeof newVal === "number" && newVal >= 0 && newVal <= 1) {
        this.changeEffectVolume(newVal);
      }
    },
  },
  mounted() {
    this.player = new eventAudio({
      src: this.src,
      index: this.index,
      loop: this.loop,
      volume: this.volume,
      preload: this.preload,
      autoplay: this.autoplay,
      cache: this.cache,
      storageKey: this.storageKey,
      storageKeySuffix: this.storageKeySuffix,
      fade: this.fade,
      html5: false,
      seekInterval: this.seekInterval,
      onEnd: (index) => {
        this.$emit("end", index);
      },
      onPlayError: () => {
        this.$emit("playError");
      },
      onPlayed: (isplayed) => {
        this.isplayed = isplayed;
        this.$emit("played", this.isplayed);
      },
      onPlaying: (state) => {
        this.$emit("playing", state);
      },
    });

    if (this.effectSrc) {
      this.initEffectPlayer(this.effectSrc);
    }

    Vue.prototype.$effectPlayer = {
      play: this.playEffect,
      stop: this.stopEffect,
      changeVolume: this.changeEffectVolume,
    };
  },

  beforeDestroy() {
    this.player?.unload();
    this.effectPlayer?.unload();
  },
  methods: {
    handlePlay() {
      if (this.doPlay) {
        if (!this.isplayed) {
          this.play();
        } else {
          this.pause();
        }
      }
      this.$emit("tap", this.isplayed);
    },
    play() {
      this.player.play();
    },
    pause() {
      this.player.pause();
    },
    stop() {
      this.player.stop();
    },
    initEffectPlayer(config) {
      this.isSprite = !!config.sprite;
      if (!!config && Array.isArray(config) && config.length === 0) {
        return;
      }
      const compConfig = Array.isArray(config)
        ? {
            src: config,
          }
        : config;
      this.effectPlayer = new eventAudio({
        cache: false,
        preload: true,
        loop: false,
        autoplay: false,
        fade: [0, 0],
        volume: this.volume,
        html5: false,
        ...compConfig,
        ...this.effectConfig,
        onPlayError: () => {
          this.$emit("effectPlayError");
        },
        onEnd: (index) => {
          this.$emit("effectEnd", index);
        },
      });
    },
    playEffect(key, ignore) {
      if (!this.effectPlayer) {
        throw Error("未初始化");
      }

      if (!this.isplayed && !ignore) {
        return;
      }

      if (this.isSprite) {
        this.effectPlayer.play(key);
      } else {
        this.effectPlayer.switchSrcIndex(key);
        this.effectPlayer.play();
      }
    },
    stopEffect() {
      this.effectPlayer?.stop();
    },
    changeEffectVolume(val) {
      this.effectPlayer?.changeVolume(val);
    },
  },
};
</script>
<style lang="scss">
.audio_play {
  position: relative;
  cursor: pointer;
  &__icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    &--hover {
      opacity: 0;
      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
